<script lang="ts">
    import { fly } from "svelte/transition";
    import { clickOutside } from "svelte-outside";
    import { onDestroy } from "svelte";
    import { inBackgroundSettingsStore } from "../../../Stores/MediaStore";
    import MediaSettingsListHeader from "./MediaSettingsListHeader.svelte";
    import MediaSettingsPanel from "./MediaSettingsPanel.svelte";
    import BackgroundSettingsPanel from "./BackgroundSettingsPanel.svelte";
    import type { ContentAction } from "../../../Utils/svelte-floatingui";

    interface Props {
        mediaSettingsDisplayed?: boolean;
        floatingAction: ContentAction;
        onclose?: () => void;
    }

    let { mediaSettingsDisplayed = $bindable<boolean>(), floatingAction, onclose }: Props = $props();

    if (mediaSettingsDisplayed === undefined) {
        mediaSettingsDisplayed = false;
    }

    let mode: "settings" | "background" = $state("settings");
    const motionDuration = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 200;

    $effect(() => {
        inBackgroundSettingsStore.set(mode === "background");
    });

    onDestroy(() => {
        inBackgroundSettingsStore.set(false);
    });

    function handleClose() {
        onclose?.();
    }

    function handleCameraSelected() {
        mediaSettingsDisplayed = false;
    }

    function handleSettingsOpened() {
        mediaSettingsDisplayed = false;
    }
</script>

<div
    data-testid="media-settings-panel"
    class="w-64 max-w-[calc(100dvw-16px)] overflow-y-auto rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] pb-2 text-[var(--nutrivera-shell-text)] shadow-[0_8px_24px_rgb(0_0_0/38%)]"
    in:fly={{ y: 12, duration: motionDuration }}
    use:floatingAction
    use:clickOutside={handleClose}
>
    <div class="relative flex max-h-[calc(100dvh-80px)] flex-col gap-2 p-1">
        <div class="sticky top-0 z-20 -mx-1 px-1 pt-1 -mt-1">
            <MediaSettingsListHeader bind:mode />
        </div>

        <div class="flex flex-col gap-2 flex-1 min-h-0">
            {#if mode === "settings"}
                <MediaSettingsPanel oncameraselected={handleCameraSelected} onsettingsopened={handleSettingsOpened} />
            {:else if mode === "background"}
                <BackgroundSettingsPanel />
            {/if}
        </div>
    </div>
</div>
